import StaticFooterLegal from './StaticFooterLegal';
export default StaticFooterLegal;